import BLCartOrderItem from './bl-cart-order-item'

export default BLCartOrderItem
